export default __webpack_public_path__ + "57abc6e126c0d73d2ed6ba9d33fa46d8.jpg";